module.exports = __WEBPACK_EXTERNAL_MODULE_react__;


//////////////////
// WEBPACK FOOTER
// external "react"
// module id = react
// module chunks = index